import { effects } from 'redux-saga'

export default function* getHmac() {
  const state = yield effects.select()

  return state.authentication.get('hmac', null)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/hmac.js